import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reduxReactFirebase } from 'redux-react-firebase';
import { firebaseConfig } from '../constants/app';
import rootReducer from '../reducers';

export default function configure(initialState) {
  const store = createStore(rootReducer, initialState, composeWithDevTools(
    reduxReactFirebase({ ...firebaseConfig, userProfile: 'members' }),
  ));

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers'); // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}



// WEBPACK FOOTER //
// ./src/store/index.js